import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import * as moment from 'moment';
import {fetchApplications} from '../actions';
import PaginatedList from './PaginatedList';

class Applications extends Component {
    render() {
        const {fetchApplications, applications, match, location: {search}} = this.props;
        const columns = [{
            title: 'Business Name',
            dataIndex: 'business_name',
            key: 'business_name',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `${match.url}/${record.id}`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Address Line 1',
            dataIndex: 'address_line_1',
            key: 'address_line_1'
        }, {
            title: 'Address Line 2',
            dataIndex: 'address_line_2',
            key: 'address_line_2'
        }, {
            title: 'Address Line 3',
            dataIndex: 'address_line_3',
            key: 'address_line_3'
        }, {
            title: 'Postcode',
            dataIndex: 'post_code',
            key: 'post_code'
        }, {
            title: 'Main Contact',
            dataIndex: 'contact_name',
            key: 'contact_name'
        }, {
            title: 'Main Contact Tel.',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Main Contact Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: 'Contact Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (createdAt, record) => (
                <span>
                    {moment(createdAt.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                </span>
            )
        }];

        return (
            <PaginatedList
                fetchData={fetchApplications}
                columns={columns}
                source={applications}
                {...this.props}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.applications.isFetching,
        applications: state.applications.data,
        meta: state.applications.meta
    };
}
export default withRouter(connect(mapStateToProps, {fetchApplications})(Applications));


// WEBPACK FOOTER //
// ./resources/assets/js/components/Applications.js